(() => {
  const roots = document.querySelectorAll('.vbrand');
  if (!roots.length || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  document.documentElement.classList.add('vbrand-enhanced');

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

  roots.forEach((root) => {
    root.querySelectorAll('[data-vbrand-reveal]').forEach((element) => observer.observe(element));
  });
})();
